(function () {
    'use strict';

    function ReserveListComponentController(__config, $scope, $state, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, OrderBagServiceItemCustom, $translate) {
        //

        var $ctrl = this;
        $ctrl.loadPage = loadPage;
        $ctrl.loadAll = loadAll;
        $ctrl.orderBagServiceItems = [];
        $ctrl.__config = __config;
        $ctrl.findStatusStyle = findStatusStyle;
        $ctrl.findStatusTitle = findStatusTitle;

        loadAll();
        loadPage();

        function loadAll() {

            searchOrderBag();
        }

        function loadPage() {
            translatePartialLoader.addPart('orderBag');
            translatePartialLoader.addPart('customer');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('servant');
            translatePartialLoader.addPart('customerStatus');
            translatePartialLoader.addPart('orderBagServiceItem');
            translatePartialLoader = translate.refresh();
        }


        function searchOrderBag() {

            makeSearchQuery();

            OrderBagServiceItemCustom.searchOrderBagItemsByQuery().save($ctrl.searchQuery, function (data) {
                $ctrl.orderBagServiceItems = data;
            });
        }


        function makeSearchQuery() {
            $ctrl.searchQuery = {};
            if ($ctrl.customerId)
                $ctrl.searchQuery.customerId = $ctrl.customerId;

            if (!$ctrl.fromDate)
                $ctrl.searchQuery.fromDate = new Date(2000, 1, 1);

            $ctrl.searchQuery.status = [1, 4, 5, 6];

        }

        function findStatusStyle(status) {
            return "order-bag-status-" + status;
        }

        function findStatusTitle(status) {
            var result = "";
            result = $translate.instant("tikonApp.orderBag.status." + status);
            return result;
        }
    }

    var ReserveListComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/reserve-list/partial-form.reserve-list.html',
        controller: ReserveListComponentController,
        bindings:
            {
                customerId: '=',
                fromDate: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('pfReserveList', ReserveListComponent)

    ReserveListComponentController.$inject = ['__config', '$scope', '$state', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'OrderBagServiceItemCustom', '$translate'];


})();

